import React from 'react';
import { render } from 'react-dom';
import PromptContainer from './PromptContainer'; // import PropTypes from 'prop-types';
// import classNames from 'classnames';
// import KZUIComponent from '../base/index';

import './style.less';
var promptInst = null;

var getPromptInst = function getPromptInst() {
  if (!promptInst) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    promptInst = render( /*#__PURE__*/React.createElement(PromptContainer, null), div);
  }

  return promptInst;
};

var prompt = {
  alert: function alert(msg, onConfirm) {
    var inst = getPromptInst();
    inst.add({
      msg: msg,
      onConfirm: onConfirm,
      type: 'alert'
    });
  },
  confirm: function confirm(msg, onConfirm, onCancel) {
    var inst = getPromptInst();
    inst.add({
      msg: msg,
      onConfirm: onConfirm,
      onCancel: onCancel,
      type: 'confirm'
    });
  }
};
export default prompt;